/**  
 * FetchStateService
 * Page/Class name   : FetchStateService
 * Author            :
 * Created Date      : 10-9-2020
 * Functionality     : constructor, componentDidMount , componentWillUnmount, getTweetRecords
 * Purpose           : api service page
**/
import {Component } from 'react';
// import {getEndPoint,getTokenFromLocStorage, callApi} from  '../../common_utilities/commonjsfunc';
// newly added axios
//import axios from 'axios';
import {axiosCustomObj} from '../customisedthirdparty/AxiosCustom';

import {commonJsFuncModule as commonJsObj} from  '../../common_utilities/commonjsfunc';
const callApi = commonJsObj.callApi;
const getTokenFromLocStorage = commonJsObj.getTokenFromLocStorage;
const getOffsetOfLocalDateTime = commonJsObj.getOffsetOfLocalDateTime;
const getMaxPageSize = commonJsObj.getMaxPageSize;


class FetchStateService extends Component {

    
    /**  
     * FetchStateService
     * Function name : constructor
     * Author        :
     * Created Date  : 10-9-2020
     * Purpose       : initializing state
     * Params        : 
    **/
    constructor() {
      super();
      this.state = {
          
      }

      //this.axiosObj = axios;
      this.axiosObj = null;
      
      this.apiEndPoint = commonJsObj.getEndPoint()+'rest/address/states';
    }

    /**  
     * FetchStateService
     * Function name : componentDidMount
     * Author        :
     * Created Date  : 10-9-2020
     * Purpose       : life cycle method
     * Params        : 
    **/
    componentDidMount() {
    }

    /**  
     * TypeOfProfessionalsService
     * Function name : componentWillUnmount
     * Author        :
     * Created Date  : 10-9-2020
     * Purpose       : life cycle method
     * Params        : 
    **/
    componentWillUnmount() {  
    }



    /**  
     * getStateList
     * Function name : getStateList
     * Author        :
     * Created Date  : 10-9-2020
     * Purpose       : get state list
     * Params        : paramObj
    **/
    async getStateList(paramObj){
      //console.log(" paramObj==>",paramObj);
      this.axiosObj = axiosCustomObj({});
      let accToken = getTokenFromLocStorage();   
      let offsetOfLocalDateTime = getOffsetOfLocalDateTime(new Date());

      try{
            let urldata =this.apiEndPoint; 

            let defaultPageSize = getMaxPageSize();
            let offsetHr = offsetOfLocalDateTime.hr;
            let offsetMin = offsetOfLocalDateTime.min;
            
            //let paramObjData = paramObj.data;
            //let pageNum = paramObjData.pageNum?paramObjData.pageNum:1;
            //let pageSize = paramObjData.pageSize?paramObjData.pageSize:defaultPageSize;
           
            urldata = urldata+"/?offset_hour="+offsetHr+"&offset_minute="+offsetMin;//+"&page_number="+pageNum+"&page_size="+pageSize;
            
            let headerOptn = {  
              "Content-Type": "application/json",
              "Authorization": accToken
            };          

            let respObj = this.axiosObj.get(urldata,{
            headers: headerOptn
            });

            return respObj;
    }
    catch(err){
        console.log("Some error occured===>",err); // TypeError: failed to fetch
    }
      

    }

    
}
export default FetchStateService;